export default class MigrateFavoriteAnswers {
  constructor(context) {
    this.context = context;
  }

  run() {
    const agentPreferences = this.context.stores.agentPreferences.get();
    const ids = agentPreferences.favoriteAnswerIds;
    if (!ids || !ids.length) {
      return;
    }

    const promises = ids.map(answerId => this.context.gateways.favoriteAnswers.add({ answerId }));
    return Promise.all(promises);
  }
}
